module.exports = __webpack_public_path__ + "img/location-singapore-4-hover.1a334ca0.jpg";